import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 翻译上下文提供者
 * 提供翻译功能的集中访问点
 */
import React from 'react';
import { TranslationContext, } from './TranslationContext.js';
import { useTranslationState } from '../state/TranslationState.js';
import { useModelState } from '../hooks/useModelState.js';
import { useLanguageState } from '../../language/hooks/useLanguageState.js';
import { useTranslationStorage } from '../../storage/hooks/useTranslationStorage.js';
/**
 * 翻译上下文提供者组件
 * 集成翻译状态管理和翻译存储功能
 */
export const TranslationProvider = ({ children, initialSourceLanguage = 'auto', initialTargetLanguage = 'en', }) => {
    // 使用模型状态钩子
    const { model } = useModelState();
    // 使用全局语言状态钩子
    const { sourceLanguage: globalSourceLanguage, targetLanguage: globalTargetLanguage, setSourceLanguage: setGlobalSourceLanguage, setTargetLanguage: setGlobalTargetLanguage, } = useLanguageState();
    // 使用翻译状态钩子
    const { translationState, resetTranslationState, setSelectedText, setDisplayedTranslation, startStreamingTranslation, isLoading: isTranslationLoading, error: translationError, } = useTranslationState();
    // 获取翻译存储服务
    const translationStorage = useTranslationStorage();
    // 初始化语言
    React.useEffect(() => {
        // 设置全局语言状态
        setGlobalSourceLanguage(initialSourceLanguage);
        setGlobalTargetLanguage(initialTargetLanguage);
    }, [
        initialSourceLanguage,
        initialTargetLanguage,
        setGlobalSourceLanguage,
        setGlobalTargetLanguage,
    ]);
    // 包装保存翻译记录功能
    const saveTranslation = React.useCallback(async (translation) => {
        return await translationStorage.saveTranslation(translation);
    }, [translationStorage]);
    // 包装获取翻译记录功能
    const getTranslations = React.useCallback(async (documentIdentity) => {
        return await translationStorage.getTranslationsForTextDocument(documentIdentity);
    }, [translationStorage]);
    // 检查是否已缓存
    const isSelectionCached = false; // 暂时不实现缓存检查逻辑，保持简单
    // 上下文值
    const contextValue = {
        translationState: translationState, // This is the core state (originalText, translatedText, etc.)
        // Add language and model info directly to the context
        sourceLanguage: globalSourceLanguage,
        targetLanguage: globalTargetLanguage,
        model: model, // Current model ID
        // Add loading and error states for translation operations
        isLoading: isTranslationLoading, // from useTranslationState
        error: translationError, // from useTranslationState
        isSelectionCached,
        resetTranslationState,
        setSelectedText,
        setDisplayedTranslation,
        startStreamingTranslation,
        saveTranslation,
        getTranslations,
    };
    return _jsx(TranslationContext.Provider, { value: contextValue, children: children });
};
//# sourceMappingURL=TranslationProvider.js.map